import { lighten } from '@theme-ui/color'
import { useField } from 'formik'
import React from 'react'
import 'react-quill/dist/quill.snow.css'
import theme from '../../theme'
import RichTextEditor from '../RichTextEditor/RichTextEditor'

interface FormikRichTextEditorProps extends Record<string, any> {
  id?: string
  name: string
  readOnly?: boolean
}

export default function FormikRichTextEditor(props: FormikRichTextEditorProps) {
  const [field, meta, helper] = useField<string>({ name: props.name })
  const { error } = meta

  return (
    <RichTextEditor
      value={field.value}
      onChange={(content) => helper.setValue(content)}
      {...props}
      style={{
        background: error ? lighten('error', 0.35)(theme) : 'unset',
        ...props.style,
      }}
    />
  )
}
